/** Canonicalizes the two copies this repo had (one of which read "1 person
 * **have** access") into a single correct implementation. */
export function formatPeopleCount(count: number): string {
  return count === 1 ? '1 person has access' : `${count} people have access`
}
